import { createFileRoute } from "@tanstack/react-router"
import { NavigationHeader } from "@/components/e2e/layout/NavigationHeader"
import { PersonaRunHistoryScreen } from "@/components/agents/persona/PersonaRunHistoryScreen"
import { Toaster } from "@/components/ui/toaster"
import { usePageHead } from "../../../../compat/head"

/** Lịch sử chạy Cố vấn của MỘT xe — khoanh PIC ở route cha ($picId/route.tsx). */
export const Route = createFileRoute("/persona-management/$picId/runs/$carId")({
  component: PersonaRunsPage,
})

function PersonaRunsPage() {
  const { picId, carId } = Route.useParams()
  usePageHead({ title: "Cố vấn VuCar · Lịch sử AI" })
  return (
    <div className="min-h-screen bg-background">
      <NavigationHeader currentPage="persona" />
      <PersonaRunHistoryScreen picId={picId} carId={carId} />
      <Toaster />
    </div>
  )
}
